import React from 'react';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { PreviewEditor } from '@atlassian/generative-ai-modal/components/PreviewEditor';
import { MarkdownConversionError } from '../../../types/MarkdownConversionError';
export var PreviewEditorWrapper = function PreviewEditorWrapper(_ref) {
  var schema = _ref.schema,
    pmFragment = _ref.pmFragment,
    PromptEditor = _ref.PromptEditor,
    onFragmentChange = _ref.onFragmentChange;
  var jsonTransformer = React.useMemo(function () {
    return new JSONTransformer(schema);
  }, [schema]);
  var jsonDocument = React.useMemo(function () {
    var prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
    // If a failure has occured creating this, we don't know what's happened
    // and so should trigger the error boundary
    if (!prosemirrorDocument) {
      throw new MarkdownConversionError({
        message: 'Unable to transform markdown into a valid prosemirror document',
        type: 'noProseMirrorDoc'
      });
    }
    if (prosemirrorDocument.content.size === 0) {
      throw new MarkdownConversionError({
        message: 'Transforming markdown returns an empty prosemirror document',
        type: 'emptyProseMirrorDoc'
      });
    }
    try {
      // Warning -- this is asserted due to a mismatch in the editor-json-transformer
      // and renderer types.
      // jsonTransformer.encode returns a "JSONDocNode" which _should_ be runtime
      // compatible with DocNode -- but does not have compatible types.
      // See the following files for more details
      // - packages/editor/editor-json-transformer/src/types.ts
      // - packages/editor/adf-schema/src/schema/nodes/doc.ts
      return jsonTransformer.encode(prosemirrorDocument);
    } catch (_unused) {
      throw new MarkdownConversionError({
        message: 'Unable to transform markdown into a valid prosemirror document',
        type: 'invalidProseMirrorDoc'
      });
    }
  }, [jsonTransformer, pmFragment, schema.nodes.doc]);
  var onADFChange = React.useCallback(function (inputValue) {
    var document = jsonTransformer.parse(inputValue);
    onFragmentChange(document.content);
  }, [onFragmentChange, jsonTransformer]);
  return /*#__PURE__*/React.createElement(PreviewEditor, {
    defaultValue: jsonDocument,
    PromptEditor: PromptEditor,
    autoFocus: true,
    onADFChange: onADFChange
  });
};